import React from 'react';

const COGS = [
    {
        key: 'investor', src: require('../../../../images/landing-pages/home-page/investor_cog.png'), alt: 'Investor', cls: 'investor',
        tooltip: 'Free application triaging in 3 minutes. Quaiffied, diligenced deal flow. AI Diligence tools.'
    },
    {
        key: 'company', src: require('../../../../images/landing-pages/home-page/company_cog.png'), alt: 'Company', cls: 'company',
        tooltip: 'Get transaction read. Create diligence pack. Funding? 1-click connect to 40 VCs'
    },
    {
        key: 'diligentsia', src: require('../../../../images/landing-pages/home-page/diligentsia_cog.png'), alt: 'Diligentsia', cls: 'diligentsia',
        tooltip: 'Diligentsia',
    },
    {
        key: 'advisor', src: require('../../../../images/landing-pages/home-page/advisor_cog.png'), alt: 'Advisor', cls: 'advisor',
        tooltip: 'Free tools to increase margins.  New services. New client introductions.'
    },
];

const HomeCogGraphic = () => (
    <div className="lp-cog-graphic-wrap">
        <div className="lp-cog-graphic">
            {COGS.map((cog) => (
                <div className={`lp-cog lp-cog--${cog.cls}`} key={cog.key} data-tooltip={cog.tooltip} tabIndex={0}>
                    <img src={cog.src} alt={cog.alt} />
                </div>
            ))}
        </div>
        <p className="lp-cog-graphic__text">Transaction readiness, Diligence, Investor &amp; Advisor matching, Deal flow.</p>
    </div>
);

export default HomeCogGraphic;
